import React from 'react'
import { useTranslation } from 'react-i18next'
import Text, { Label } from '../../../../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import PlaceLevelSelect from '../../../../../containers/placeLevels/select/PlaceLevelSelect'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import PlaceTypeSelect from '../../../../../containers/places/select/PlaceTypeSelect'
import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'

const LevelSection = () => {
  const { t } = useTranslation('common')
  const { form } = useFormState()

  return (
    <>
      <Grid paddingGutter={0.2} wrap>
        <Col width="100%">
          <Text size="h5" marginBottom={0.2} bold>
            {t('levelConfiguration')}
          </Text>
          <Text>{t('selectLevelToApplyConfiguration')}</Text>
        </Col>

        <Col width="50%">
          <Label noMargin>{t('type')}</Label>
          <FormItem path={['value', 'conditions', 'placeLevelType']} Input={PlaceTypeSelect} returnObject />
        </Col>

        <Col width="50%">
          <Label noMargin>{t('level')}</Label>
          <FormItem
            path={['value', 'conditions', 'placeLevel']}
            type={form.value?.conditions?.placeLevelType?.key}
            Input={PlaceLevelSelect}
          />
        </Col>
      </Grid>
      <Separator weight={4} />
    </>
  )
}

export default LevelSection
